import { v4 as v4uuid } from "uuid";
import { getCurrentUser } from "./session";
import { PoliceManifestationGender } from "../Model/PoliceManifestationGender";
export class PoliceManifestationGenderService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findOneByDiligenceNumber(ndiligencia) {
        if (ndiligencia) {
            const response = await this.apiService.get('policemanifestationgender/' + ndiligencia);
            if (!response.ok) {
                throw new Error(`Error al obtener la extensión de Género manifestacion policial`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener nDiligencia`);
        }
    }
    async savePoliceManifestationGender(policeManifestation) {
        if (policeManifestation) {
            const response = await this.apiService.post('policemanifestationgender', policeManifestation);
            if (!response.ok) {
                throw new Error(`Error al guardar la la extensión de Género manifestación policial.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener la manifestación policial.`);
        }
    }
    async createPoliceManifestationGender(diligenceId) {
        if (diligenceId) {
            const policeManifestationGender = new PoliceManifestationGender({
                id: v4uuid(),
                ndiligencia: diligenceId,
                userId: getCurrentUser().id,
                ocularInspection: false,
                eyeInspectionResult: false,
                samplesInvolved: false,
                sampleTypes: " ",
                weaponsIntervene: false,
                typesWeapons: " ",
                armsWithdrawalProcedure: false,
                interestingData: " ",
                transferHealthCenter: false,
                accompanyAddressEffects: false,
                accompanyFamilyHome: false,
                transferReceptionCenter: false,
                observations: " ",
                referralDate: new Date(),
                numFoliosRemission: null,
                numReferralMinutes: null,
                independentMinutes: " ",
                numCitations: null,
                citations: " ",
                bodyTransfer: null,
            });
            const response = await this.apiService.post('policemanifestationgender', policeManifestationGender.getState());
            if (!response.ok) {
                throw new Error(`Error al guardar el denunciante de una diligencia Género`);
            }
            return policeManifestationGender;
        }
        else {
            throw new Error(`Error al obtener el denunciante`);
        }
    }
}
